<script setup lang="ts">
type SourceBadgeTheme = 'light' | 'dark'
type SourceBadgeVariant = 'primary' | 'secondary' | 'neutral'
type SourceBadgeSize = 'xsmall' | 'small' | 'medium' | 'large'

interface SourceBadgeProps {
  label: string
  theme?: SourceBadgeTheme
  variant?: SourceBadgeVariant
  size?: SourceBadgeSize
}

withDefaults(defineProps<SourceBadgeProps>(), {
  theme: 'light',
  variant: 'primary',
  size: 'medium',
})
</script>

<template>
  <div
      class="source-badge"
      :class="[variant, size, theme]"
      role="status"
  >
    {{ label }}
  </div>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/elpdl/colors" as c;
@use "~/assets/scss/partials/elpdl/index" as *;
@use "~/assets/scss/app" as *;

.source-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  border-radius: $spacing-3xs;
  white-space: nowrap;
  text-align: center;

  user-select: none;
  pointer-events: none;
}

.primary {
  background: var(--color-primary);
  color: var(--color-text-on-primary);

  &.dark {
    background: c.$enedis-interface-bleufonce-400;
  }
}

.secondary {
  background: var(--color-bg-active-primary);
  color: var(--color-primary);
  border: 1px solid var(--color-bg-active-primary);
}

.neutral {
  background: var(--color-bg-muted);
  color: var(--color-text);
}

.xsmall {
  padding: $spacing-3xs $spacing-xs;
  @extend .text-2xs;
}

.small {
  padding: $spacing-2xs $spacing-s;
  @extend .text-xs;
}

.medium {
  padding: $spacing-xs $spacing-m;
  @extend .text-s;
}

.large {
  padding: $spacing-s $spacing-l;
  @extend .text-m;
}
</style>
